import React from "react";
import "../styles/classes.css";

function Classes() {
  return (
    <div className="content">
      <h1>Classes</h1>
      <p>
        Work in Progress - A list of the coursework I have taken that may be
        relevant
      </p>
      <strong>Villanova University (Graduate)</strong>
      <ul>
        <li>Statistical Programming (STAT 7500) • R, SAS</li>
        <li>Statistical Theory I & II (STAT 8400 & 8401)</li>
        <li>Nonparametric Statistics (STAT 8452)</li>
        <li>Regression Methods (STAT 8406)</li>
        <li>Linear Methods (STAT 8412)</li>
        <li>Data Mining & Predictive Analytics (STAT 8480)</li>
      </ul>
      <strong>Northeastern University (Undergraduate)</strong>
      <ul>
        <li>
          Color and Composition & Tools (ARTF 1122 & 1123) • Adobe Photoshop,
          Adobe Illustrator, Adobe InDesign
        </li>
        <li>Discrete Structures (CS 1800) • LaTeX</li>
        <li>
          Fundamentals of Computer Science 1 & 2 Accel (CS 2500 & 2510A) • Racket (BSL, ISL) & Java
        </li>
        <li>Calculus 3 (MATH 2321)</li>
        <li>Linear Algebra (MATH 2331)</li>
        <li>Differential Equations & Linear Algebra (MATH 2341)</li>
        <li>Logic & Computation (CS 2800) • Lean 3</li>
        <li>Algorithms & Data (CS 3000)</li>
        <li>Foundation of Data Science (DS 3000) • Python, Jupyter Notebook</li>
        <li>Probability & Statistics (MATH 3081)</li>
        <li>Object-Oriented Design (CS 3500) • Java</li>
        <li>Group Theory (MATH 3175)</li>
        <li>Number Theory (MATH 3527)</li>
        <li>Numerical Analysis (MATH 3530) • Python</li>
        <li>Graph Theory (MATH 3545)</li>
        <li>Theory of Computation (CS 3800)</li>
        <li>
          Information Presentation & Visualization (DS 4200) • Python,
          JavaScript, D3
        </li>
        <li>Computer Graphics (CS 4300) • C++, OpenGL, GLSL, WebGL</li>
        <li>Human-Computer Interaction (IS 4300) • Figma, UX/UI Design</li>
        <li>Machine Learning & Data Mining 1 • Python, Pytorch</li>
        <li>Fundamentals of Software Engineering (CS 4530) • TypeScript</li>
        <li>Statistics & Stochastic Processes (MATH 4581)</li>
      </ul>
      <strong>McDonogh School (High School)</strong>
      <ul>
        <li>AP Macroeconomics and Microeconomics</li>
        <li>AP Calculus AB + BC</li>
        <li>AP Computer Science A • Java</li>
        <li>AP Physics C</li>
        <li>
          Post-AP Computer Science
          <ul>
            <li>Computational Math • Python, SageMath</li>
            <li>Computational Physics 1 & 2 • Java, Processing</li>
            <li>Cybersecurity</li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

export default Classes;
